import PropTypes from 'prop-types';
import React from 'react';
import { Lock } from './Icons';
import { Close } from '../HomeCam/Icons';
import config from '../../config';
import createAccessibleOnClick from '../../utils/createAccessibleOnClick';

const HomeCamGoPremium = ({ onClickHandler, doToggleHomeCamVisibility }) => (
  <div className="sl-home-cam-go-premium">
    <Lock className="sl-home-cam-go-premium-lock" />
    <p>Set your homecam and never miss a set again.</p>
    <a
      href={config.funnelUrl}
      onClick={() =>
        onClickHandler({
          ctaLocation: 'Home Cam',
        })
      }
    >
      Start Free Trial
    </a>
    <div
      {...createAccessibleOnClick(doToggleHomeCamVisibility)}
      className="sl-home-cam-go-premium__close"
    >
      <Close className="sl-home-cam-go-premium__close-icon" />
    </div>
  </div>
);

HomeCamGoPremium.propTypes = {
  onClickHandler: PropTypes.func.isRequired,
  doToggleHomeCamVisibility: PropTypes.func.isRequired,
};

export default HomeCamGoPremium;
